// src/components/Dashboard/Dashboard.js

// import FamilyInfo from "./FamilyInfo";
import Controllers from "./Controllers";
import Igloos from "./Igloos";
import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";

function HomeDashboard({ familyID, onReturn }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-3">
      <div className="max-w-4xl mx-auto space-y-6">
        {/* Header */}
        <div className="flex items-start gap-4">
          <div className="flex items-start gap-2 flex-1 min-w-0">
            <Button 
              onClick={onReturn}
              variant="ghost"
              size="icon"
              className="flex-shrink-0"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <div className="min-w-0 flex-1">
              <h1 className="text-2xl font-bold text-slate-900">Device Configuration</h1>
              <p className="text-slate-600">Manage spaces, families, and device controllers</p>
            </div>
          </div>
        </div>

        {/* Family Info - moved to header style */}
        {/* <FamilyInfo familyID={familyID} onReturn={onReturn} /> */}
        
        {/* Controllers Section */}
        <Controllers familyID={familyID} onReturn={onReturn} />
        
        {/* Igloos Section */}
        <Igloos familyID={familyID} />
      </div>
    </div>
  );
}

export default HomeDashboard;
